import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EzidebitRecurringCardPage } from './ezidebit-card.page';

const routes: Routes = [
  {
    path: '',
    component: EzidebitRecurringCardPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EzidebitRecurringCardPageRoutingModule {}
